
import mockData from './mock-data.js';
import DialogNotice from './widgets/dialog-notice.vue';
import DialogConfirm from './widgets/dialog-confirm.vue';
import MonthBoard from './widgets/month-board.vue';
import BellBtn from './widgets/bell-btn.vue';
import * as echarts from 'echarts/core';
import { TooltipComponent, GridComponent } from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

var settlementPdf = require('./settlement-pdf.js');
var jpegToPdf = settlementPdf.jpegToPdf;
var FOLDED_CARET = '<svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true"><path d="M5.1 2 10.4 7 5.1 12" fill="none" stroke="#fff" stroke-width="1.6"/></svg>';

function canvasToJpegPdf(canvas, cssW, cssH) {
  return new Promise(function (resolve, reject) {
    if (!canvas || !canvas.width || !canvas.height) {
      reject(new Error('empty'));
      return;
    }
    canvas.toBlob(function (blob) {
      if (!blob) {
        reject(new Error('jpeg'));
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        var jpeg = new Uint8Array(reader.result);
        resolve(jpegToPdf(jpeg, Math.max(1, cssW), Math.max(1, cssH), canvas.width, canvas.height));
      };
      reader.onerror = function () {
        reject(new Error('read'));
      };
      reader.readAsArrayBuffer(blob);
    }, 'image/jpeg', 0.92);
  });
}

function savePdfBytes(bytes, name) {
  var blob = new Blob([bytes], { type: 'application/pdf' });
  var objectUrl = window.URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = objectUrl;
  a.download = name;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function () {
    window.URL.revokeObjectURL(objectUrl);
  }, 1000);
}

function mountFoldedDashboard(source) {
  var width = Math.max(source.scrollWidth || 0, source.offsetWidth || 0, 1100);
  var host = document.createElement('div');
  host.className = 'owner-shell';
  host.setAttribute('aria-hidden', 'true');
  host.style.cssText = 'position:fixed;left:0;top:0;width:' + width + 'px;height:auto;min-height:0;z-index:-1;pointer-events:none;overflow:visible;display:block;background:#ffffff;';
  var clone = source.cloneNode(true);
  clone.classList.add('is-pdf-sheet');
  clone.style.width = width + 'px';
  clone.style.height = 'auto';
  clone.style.minHeight = '0';
  clone.style.maxWidth = 'none';
  clone.style.overflow = 'visible';
  clone.style.background = '#ffffff';

  var overlays = clone.querySelectorAll('.owner-dialog-mask, .owner-month-board-root');
  var i;
  for (i = overlays.length - 1; i >= 0; i--) {
    if (overlays[i].parentNode) overlays[i].parentNode.removeChild(overlays[i]);
  }

  var blocks = clone.querySelectorAll('.owner-room-block');
  for (i = 0; i < blocks.length; i++) {
    blocks[i].classList.remove('is-open');
    var expand = blocks[i].querySelector('.owner-room-expand');
    if (expand && expand.parentNode) expand.parentNode.removeChild(expand);
    var caret = blocks[i].querySelector('.owner-room-caret');
    if (caret) caret.innerHTML = FOLDED_CARET;
  }

  host.appendChild(clone);
  document.body.appendChild(host);
  clone.getBoundingClientRect();
  var height = Math.max(clone.scrollHeight || 0, clone.offsetHeight || 0);
  if (width < 1 || height < 1) {
    if (host.parentNode) host.parentNode.removeChild(host);
    throw new Error('empty');
  }
  return {
    host: host,
    node: clone,
    width: width,
    height: height
  };
}

export default {
  name: 'owner-dashboard',
  components: {
    BellBtn: BellBtn,
    DialogNotice: DialogNotice,
    DialogConfirm: DialogConfirm,
    MonthBoard: MonthBoard
  },
  data: function () {
    var now = new Date();
    var mock = false;
    if (this.$route && this.$route.query && this.$route.query.mock === '1') {
      mock = true;
    }
    try {
      if (!mock) {
        var flag = window.localStorage && localStorage.getItem('_ownerUiMock');
        if (flag && flag !== '0' && flag !== 'false') mock = true;
      }
    } catch (e) {}
    var y = mock ? mockData.year : now.getFullYear();
    return {
      year: y,
      kpis: { sales: '', profit: '—', occupancy: '' },
      rooms: [],
      chart: {
        yearA: y,
        yearB: y - 1 < 2000 ? 2000 : y - 1,
        seriesA: [],
        seriesB: [],
        hiddenA: [],
        hiddenB: []
      },
      yearPopA: false,
      yearPopB: false,
      facilityName: mockData.facilityName,
      expanded: null,
      calYear: y,
      calMonth: now.getMonth() + 1,
      selectedDays: [],
      stayApplications: [],
      weeks: ['日', '月', '火', '水', '木', '金', '土'],
      occupiedDays: [3, 4, 5, 12, 18, 19, 25],
      calendarDays: [],
      noticeVisible: false,
      noticeTitle: '通知',
      noticeBody: '',
      cancelConfirmVisible: false,
      cancelConfirmBody: 'オーナー利用の取消可能期間は\n宿泊日の3日前までとなります。',
      cancelTarget: null,
      monthBoardVisible: false,
      monthBoardType: 'market_report',
      monthBoardKind: 'publication',
      monthBoardLive: true,
      monthBoardFocusYear: 0,
      monthBoardFocusMonth: 0,
      calMonthPickerVisible: false,
      calPickerYear: y,
      calPickerMonth: now.getMonth() + 1,
      dataYears: [],
      pdfBusy: false,
      hidePickerVisible: false,
      hideRoomId: null,
      helpVisible: false,
      hideDraft: [true, true, true, true, true, true, true, true, true, true, true, true],
      pickerMonths: {}
    };
  },
  computed: {
    yearOptions: function () {
      return this.yearsFromApi();
    },
    chartYearOptions: function () {
      return this.yearsFromApi();
    },
    calPickerTitle: function () {
      var i;
      for (i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].id === this.expanded) return this.rooms[i].name;
      }
      return this.facilityName;
    },
    hidePickerTitle: function () {
      var i;
      for (i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].id === this.hideRoomId) return this.rooms[i].name;
      }
      return this.facilityName;
    },
    chartMonthLabel: function () {
      var hidden = this.chart.hiddenA || [];
      var parts = [];
      var i;
      for (i = 0; i < 12; i++) {
        if (hidden[i]) continue;
        parts.push(String(i + 1));
      }
      if (!parts.length) return '万円';
      return parts.join(' ') + '（月）　万円';
    },
    applicationRows: function () {
      var rows = [];
      var drafts = this.draftGroups();
      var i;
      var span;
      var stay;
      for (i = 0; i < drafts.length; i++) {
        span = drafts[i];
        rows.push({
          key: 'draft-' + span.start + '-' + span.end,
          label: this.formatDateSpan(span.start, span.end),
          stateLabel: '未送信',
          canCancel: false
        });
      }
      var stays = this.stayApplications || [];
      for (i = 0; i < stays.length; i++) {
        stay = stays[i];
        rows.push({
          key: 'stay-' + stay.id,
          id: stay.id,
          label: this.formatDateSpan(stay.stay_date, stay.date_to || stay.stay_date),
          stateLabel: stay.status === 'approved' ? '承認済み' : '処理待ち',
          canCancel: stay.status === 'pending'
        });
      }
      return rows;
    },
    calPickerYearOptions: function () {
      return this.mergeYears(this.dataYears, [this.calPickerYear, this.calYear]);
    },
    isMock: function () {
      if (this.$route && this.$route.query && this.$route.query.mock === '1') {
        return true;
      }
      try {
        var flag = window.localStorage && localStorage.getItem('_ownerUiMock');
        if (flag && flag !== '0' && flag !== 'false') {
          return true;
        }
      } catch (e) {}
      return false;
    }
  },
  watch: {
    year: function () {
      this.selectedDays = [];
      this.calYear = this.year;
      this.chart.yearA = this.year;
      this.chart.yearB = this.defaultChartYearB(this.year);
      this.loadDashboard(true);
    },
    '$route.query': function () {
      this.applyNoticeQuery();
    },
    expanded: function () {
      this.scheduleOwnerChart();
    },
    calPickerYear: function () {
      if (!this.calMonthPickerVisible) return;
      this.ensurePickerMonths(this.expanded, this.calPickerYear);
    }
  },
  created: function () {
    echarts.use([
      TooltipComponent,
      GridComponent,
      LineChart,
      CanvasRenderer,
      UniversalTransition
    ]);
    this.$eventBus.$on('owner-mock-collapse-rooms', this.onMockCollapse);
    this.$eventBus.$on('owner-mock-expand-rooms', this.onMockExpand);
    this.$eventBus.$on('owner-mock-empty-rooms', this.onMockEmptyRooms);
    this.calYear = this.year;
    this._pickerLoads = {};
    this.loadDashboard();
  },
  mounted: function () {
    this._onOwnerChartResize = this.resizeOwnerChart.bind(this);
    this._onHelpKeydown = this.onHelpKeydown.bind(this);
    window.addEventListener('resize', this._onOwnerChartResize);
    window.addEventListener('keydown', this._onHelpKeydown);
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this._onOwnerChartResize);
    window.removeEventListener('keydown', this._onHelpKeydown);
    this.disposeOwnerChart();
    this.$eventBus.$off('owner-mock-collapse-rooms', this.onMockCollapse);
    this.$eventBus.$off('owner-mock-expand-rooms', this.onMockExpand);
    this.$eventBus.$off('owner-mock-empty-rooms', this.onMockEmptyRooms);
  },
  methods: {
    onHelpKeydown: function (e) {
      if (e.key === 'Escape' && this.helpVisible) this.helpVisible = false;
    },
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    visibleMonths: function (room) {
      var list = (room && room.months) || [];
      var out = [];
      var i;
      var cell;
      for (i = 0; i < list.length; i++) {
        cell = list[i] || {};
        if (cell.hidden || cell.bookable === false) continue;
        out.push({
          month: cell.month || (i + 1),
          occupancy: cell.occupancy,
          sales: cell.sales,
          days: cell.days
        });
      }
      return out;
    },
    syncPickerMonths: function (roomId, year, months) {
      var flags = {};
      var i;
      var cell;
      var m;
      var available;
      var bookable;
      for (i = 0; i < (months || []).length; i++) {
        cell = months[i] || {};
        m = Number(cell.month || (i + 1));
        if (m < 1 || m > 12) continue;
        if (cell.bookable === false) {
          flags[m] = false;
          continue;
        }
        if (cell.bookable === true) {
          flags[m] = true;
          continue;
        }
        available = cell.available_days;
        bookable = available == null || available === '' || Number(available) > 0;
        flags[m] = bookable;
      }
      this.$set(this.pickerMonths, String(roomId) + ':' + String(year), flags);
    },
    rememberRoomMonths: function () {
      var i;
      for (i = 0; i < this.rooms.length; i++) {
        this.syncPickerMonths(this.rooms[i].id, this.year, this.rooms[i].months);
      }
    },
    monthSelectable: function (roomId, year, month) {
      var flags = this.pickerMonths[String(roomId) + ':' + String(year)];
      if (!flags) return false;
      return !!flags[Number(month)];
    },
    ensurePickerMonths: function (roomId, year) {
      var key;
      var room;
      var i;
      var t;
      if (!roomId || !year) return;
      key = String(roomId) + ':' + String(year);
      if (this.pickerMonths[key]) return;
      if (Number(year) === Number(this.year)) {
        for (i = 0; i < this.rooms.length; i++) {
          if (Number(this.rooms[i].id) === Number(roomId)) {
            room = this.rooms[i];
            break;
          }
        }
        this.syncPickerMonths(roomId, year, room ? room.months : []);
        return;
      }
      if (this.isMock) {
        this.syncPickerMonths(roomId, year, []);
        return;
      }
      if (!this._pickerLoads) this._pickerLoads = {};
      if (this._pickerLoads[key]) return;
      this._pickerLoads[key] = true;
      t = this;
      axios.get('landlord/dashboard', {
        params: { year: year, year_a: year, year_b: year }
      }).then(function (res) {
        var rooms = (res.data && res.data.options && res.data.options.rooms) || [];
        var found = null;
        var n;
        for (n = 0; n < rooms.length; n++) {
          if (Number(rooms[n].room_id) === Number(roomId)) found = rooms[n];
        }
        t.syncPickerMonths(roomId, year, found ? (found.months || []) : []);
      }).catch(function () {
        t.syncPickerMonths(roomId, year, []);
      });
    },
    openHidePicker: function (room) {
      if (!room) return;
      var draft = [];
      var i;
      var cell;
      var month;
      for (i = 0; i < 12; i++) draft.push(true);
      var months = room.months || [];
      for (i = 0; i < months.length; i++) {
        cell = months[i] || {};
        month = Number(cell.month || (i + 1));
        if (month >= 1 && month <= 12 && cell.hidden) draft[month - 1] = false;
      }
      this.hideRoomId = room.id;
      this.hideDraft = draft;
      this.hidePickerVisible = true;
    },
    toggleHideDraft: function (month) {
      var i = Number(month) - 1;
      if (i < 0 || i > 11) return;
      if (!this.monthSelectable(this.hideRoomId, this.year, month)) return;
      this.$set(this.hideDraft, i, !this.hideDraft[i]);
    },
    saveHideMonths: function () {
      var hidden = [];
      var i;
      for (i = 0; i < 12; i++) {
        if (!this.hideDraft[i]) hidden.push(i + 1);
      }
      if (this.isMock) {
        this.applyLocalHide(this.hideRoomId, hidden);
        this.hidePickerVisible = false;
        return;
      }
      if (!this.hideRoomId) return;
      var t = this;
      axios.post('landlord/monthHide', {
        room_id: this.hideRoomId,
        year: this.year,
        hidden_months: hidden
      }).then(function (res) {
        if (!res.data || res.data.status != 1) {
          t.toast('保存に失敗しました');
          return;
        }
        t.hidePickerVisible = false;
        t.loadDashboard(true);
      }).catch(function () {
        t.toast('保存に失敗しました');
      });
    },
    applyLocalHide: function (roomId, hidden) {
      var i;
      var room;
      var months;
      var cell;
      var month;
      var set = {};
      for (i = 0; i < hidden.length; i++) set[hidden[i]] = true;
      for (i = 0; i < this.rooms.length; i++) {
        room = this.rooms[i];
        if (room.id !== roomId) continue;
        months = (room.months || []).slice();
        months = months.map(function (item, idx) {
          cell = item || {};
          month = Number(cell.month || (idx + 1));
          return {
            month: month,
            hidden: !!set[month],
            occupancy: cell.occupancy,
            sales: cell.sales,
            salesRaw: cell.salesRaw,
            days: cell.days
          };
        });
        this.$set(room, 'months', months);
      }
      this.adjustChartYear('seriesA', 'hiddenA', 'yearA');
      this.adjustChartYear('seriesB', 'hiddenB', 'yearB');
    },
    adjustChartYear: function (seriesKey, hiddenKey, yearKey) {
      if (Number(this.chart[yearKey]) !== Number(this.year)) return;
      var series = (this.chart[seriesKey] || []).slice();
      var flags = [];
      var total = this.rooms.length;
      var i;
      var r;
      var months;
      var cell;
      var month;
      var j;
      for (i = 0; i < 12; i++) {
        var visible = 0;
        var yen = 0;
        var hasRaw = false;
        for (r = 0; r < this.rooms.length; r++) {
          months = this.rooms[r].months || [];
          cell = null;
          for (j = 0; j < months.length; j++) {
            month = Number((months[j] && months[j].month) || (j + 1));
            if (month === i + 1) {
              cell = months[j];
              break;
            }
          }
          if (cell && cell.hidden) continue;
          visible++;
          if (cell && cell.salesRaw != null && cell.salesRaw !== '') {
            hasRaw = true;
            yen += Number(cell.salesRaw) || 0;
          }
        }
        if (total > 0 && visible === 0) {
          flags.push(true);
        } else {
          flags.push(false);
          if (hasRaw) series[i] = Math.round((yen / 10000) * 10) / 10;
        }
      }
      this.chart[seriesKey] = series;
      this.chart[hiddenKey] = flags;
    },
    yearsFromApi: function () {
      var set = {};
      var list = this.dataYears || [];
      var i;
      var y;
      for (i = 0; i < list.length; i++) {
        y = Number(list[i]);
        if (isFinite(y) && y >= 2000 && y <= 2100) set[y] = true;
      }
      return Object.keys(set).map(function (k) {
        return parseInt(k, 10);
      }).sort(function (a, b) {
        return a - b;
      });
    },
    defaultChartYearB: function (year) {
      var years = this.yearsFromApi();
      var y = Number(year);
      var i;
      if (!isFinite(y)) y = (new Date()).getFullYear();
      for (i = years.length - 1; i >= 0; i--) {
        if (years[i] < y) return years[i];
      }
      if (years.length) return years[years.length - 1];
      return y - 1 < 2000 ? 2000 : y - 1;
    },
    mergeYears: function (fromApi, extras) {
      var set = {};
      var nowY = (new Date()).getFullYear();
      var list = fromApi || [];
      var i;
      var y;
      if (list.length) {
        for (i = 0; i < list.length; i++) {
          y = Number(list[i]);
          if (isFinite(y) && y >= 2000 && y <= 2100) set[y] = true;
        }
      } else {
        for (y = nowY - 2; y <= nowY; y++) set[y] = true;
      }
      for (i = 0; i < (extras || []).length; i++) {
        y = Number(extras[i]);
        if (isFinite(y) && y >= 2000 && y <= 2100) set[y] = true;
      }
      return Object.keys(set).map(function (k) {
        return parseInt(k, 10);
      }).sort(function (a, b) {
        return a - b;
      });
    },
    onChartYearChange: function () {
      this.loadDashboard(true);
    },
    formatOcc: function (n) {
      var v = Number(n);
      if (!isFinite(v)) v = 0;
      if (v === 100) return '100％';
      return v.toFixed(2) + '％';
    },
    formatYen: function (n) {
      var v = Math.round(Number(n));
      if (!isFinite(v)) v = 0;
      return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '円';
    },
    formatManYen: function (yen) {
      var v = Number(yen) / 10000;
      if (!isFinite(v)) v = 0;
      if (Math.abs(v) < 0.0000001) return '0万';
      if (Math.abs(v - Math.round(v)) < 0.05) return Math.round(v) + '万';
      return (Math.round(v * 100) / 100) + '万';
    },
    formatKpiOcc: function (n) {
      var v = Number(n);
      if (!isFinite(v)) v = 0;
      return v + '％';
    },
    stayStateClass: function (row) {
      var label = row && row.stateLabel ? row.stateLabel : '';
      if (label === '処理待ち' || label === '未送信') return 'is-wait';
      if (label === '承認済み') return 'is-done';
      return 'is-muted';
    },
    occCellStyle: function (n) {
      var v = Number(n);
      if (!isFinite(v) || v < 0) v = 0;
      if (v > 100) v = 100;
      var alpha = 0.2 + (v / 100) * 0.8;
      return { background: 'rgba(216, 131, 132, ' + alpha.toFixed(3) + ')' };
    },
    profitText: function (room) {
      if (!room || room.profit == null || room.profit === '' || room.profit === '—') return '—';
      return room.profit + '　円';
    },
    loadDashboard: function (keepExpanded) {
      if (this.isMock) {
        this.applyMockDashboard(keepExpanded);
        return;
      }
      var t = this;
      axios.get('landlord/dashboard', {
        params: {
          year: this.year,
          year_a: this.chart.yearA,
          year_b: this.chart.yearB
        }
      }).then(function (res) {
        if (res.data.status == 1 && res.data.options) {
          t.applyDashboard(res.data.options, keepExpanded);
        } else {
          t.toast('読み込みに失敗しました');
        }
      }).catch(function () {
        t.toast('読み込みに失敗しました');
      });
    },
    applyDashboard: function (opt, keepExpanded) {
      var t = this;
      var kpis = opt.kpis || {};
      var profitConfirmed = kpis.profit_confirmed;
      this.kpis = {
        sales: this.formatYen(kpis.sales_confirmed),
        profit: profitConfirmed === null || profitConfirmed === undefined ? '—' : this.formatYen(profitConfirmed),
        occupancy: this.formatKpiOcc(kpis.occupancy_avg)
      };
      var prev = this.expanded;
      var rooms = opt.rooms || [];
      this.rooms = rooms.map(function (r) {
        var yearly = r.yearly || {};
        var months = r.months || [];
        return {
          id: r.room_id,
          name: r.name,
          active: r.active !== false,
          address: r.address,
          frontend: r.frontend,
          profit: t.formatYen(yearly.sales).replace(/円$/, ''),
          yearly: {
            occupancy: yearly.occupancy,
            sales: t.formatManYen(yearly.sales),
            days: Math.round(Number(yearly.days) || 0)
          },
            months: months.map(function (cell, idx) {
            var available = cell.available_days;
            var bookable = available == null || available === '' || Number(available) > 0;
            return {
              month: cell.month || (idx + 1),
              hidden: !!cell.hidden,
              bookable: bookable,
              occupancy: cell.occupancy,
              sales: t.formatManYen(cell.sales),
              salesRaw: cell.sales,
              days: Math.round(Number(cell.days) || 0)
            };
          })
        };
      });
      this.rooms.sort(function (a, b) {
        var aa = a.active === false ? 1 : 0;
        var bb = b.active === false ? 1 : 0;
        if (aa !== bb) return aa - bb;
        return Number(a.id) - Number(b.id);
      });
      var chart = opt.chart || {};
      this.chart.yearA = chart.year_a != null ? Number(chart.year_a) : Number(this.year);
      this.chart.yearB = chart.year_b != null ? Number(chart.year_b) : this.defaultChartYearB(this.year);
      this.chart.seriesA = chart.series_a || [];
      this.chart.seriesB = chart.series_b || [];
      this.chart.hiddenA = chart.hidden_a || [];
      this.chart.hiddenB = chart.hidden_b || [];
      if (opt.years && Array.isArray(opt.years)) {
        this.dataYears = opt.years.map(function (y) { return Number(y); }).filter(function (y) {
          return isFinite(y) && y >= 2000;
        });
      }
      var knownYears = this.yearsFromApi();
      var reloadYears = false;
      if (knownYears.length && knownYears.indexOf(Number(this.chart.yearA)) < 0) {
        this.chart.yearA = knownYears[knownYears.length - 1];
        reloadYears = true;
      }
      if (knownYears.length && knownYears.indexOf(Number(this.chart.yearB)) < 0) {
        var pick = knownYears[knownYears.length - 1];
        var yi;
        for (yi = knownYears.length - 1; yi >= 0; yi--) {
          if (knownYears[yi] !== Number(this.chart.yearA)) {
            pick = knownYears[yi];
            break;
          }
        }
        this.chart.yearB = pick;
        reloadYears = true;
      }
      if (knownYears.length && knownYears.indexOf(Number(this.year)) < 0) {
        this.year = knownYears[knownYears.length - 1];
        return;
      }
      if (reloadYears) {
        this.loadDashboard(keepExpanded);
        return;
      }
      if (this.rooms[0]) {
        this.facilityName = this.rooms[0].name || this.facilityName;
      }
      this.syncExpanded(prev, keepExpanded);
      this.rememberRoomMonths();
      this.scheduleOwnerChart();
    },
    applyMockDashboard: function (keepExpanded) {
      var prev = this.expanded;
      this.kpis = mockData.kpis;
      this.rooms = mockData.emptyRooms ? [] : mockData.rooms;
      this.dataYears = mockData.year ? [mockData.year] : [(new Date()).getFullYear()];
      this.chart = {
        yearA: mockData.chart.yearA,
        yearB: mockData.chart.yearB,
        seriesA: mockData.chart.seriesA.slice(),
        seriesB: mockData.chart.seriesB.slice(),
        hiddenA: [],
        hiddenB: []
      };
      this.facilityName = mockData.facilityName;
      this.occupiedDays = [3, 4, 5, 12, 18, 19, 25];
      this.syncExpanded(prev, keepExpanded);
      this.rememberRoomMonths();
      this.scheduleOwnerChart();
    },
    syncExpanded: function (prev, keepExpanded) {
      if (!this.rooms.length) {
        this.expanded = null;
        this.calendarDays = [];
        return;
      }
      var qRoom = this.roomIdFromQuery();
      var next = this.rooms[0].id;
      if (qRoom != null) {
        next = qRoom;
      } else if (keepExpanded) {
        if (prev == null) {
          this.expanded = null;
          return;
        }
        var i;
        for (i = 0; i < this.rooms.length; i++) {
          if (this.rooms[i].id === prev) {
            next = prev;
            break;
          }
        }
      }
      this.expanded = next;
      if (!keepExpanded) {
        this.applyCalFromQuery();
      }
      this.focusBookableMonth(next);
      this.loadCalendar(next);
    },
    roomIdFromQuery: function () {
      var q = (this.$route && this.$route.query) || {};
      var roomId = parseInt(q.room_id, 10);
      if (!isFinite(roomId) || roomId <= 0) return null;
      var i;
      for (i = 0; i < this.rooms.length; i++) {
        if (Number(this.rooms[i].id) === roomId) return this.rooms[i].id;
      }
      return null;
    },
    applyCalFromQuery: function () {
      var q = (this.$route && this.$route.query) || {};
      var y = parseInt(q.cal_year, 10);
      var m = parseInt(q.cal_month, 10);
      if (!isFinite(y) || !isFinite(m) || m < 1 || m > 12) return false;
      if (Number(this.calYear) === y && Number(this.calMonth) === m) return false;
      this.calYear = y;
      this.calMonth = m;
      return true;
    },
    applyNoticeQuery: function () {
      if (!this.rooms.length) return;
      var calChanged = this.applyCalFromQuery();
      var qRoom = this.roomIdFromQuery();
      if (qRoom != null) {
        if (this.expanded !== qRoom || calChanged) {
          if (this.expanded !== qRoom) this.selectedDays = [];
          this.expanded = qRoom;
          this.loadCalendar(qRoom);
        }
      } else if (calChanged && this.expanded) {
        this.loadCalendar(this.expanded);
      }
    },
    focusBookableMonth: function (roomId) {
      var room = null;
      var i;
      for (i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].id === roomId) {
          room = this.rooms[i];
          break;
        }
      }
      if (!room) return;
      var months = this.visibleMonths(room);
      if (!months.length) return;
      var boardYear = Number(this.year);
      var month = Number(this.calMonth);
      var i2;
      if (Number(this.calYear) === boardYear) {
        for (i2 = 0; i2 < months.length; i2++) {
          if (Number(months[i2].month) === month) return;
        }
      }
      this.calYear = boardYear;
      this.calMonth = Number(months[months.length - 1].month);
    },
    loadCalendar: function (roomId) {
      if (!roomId) {
        this.calendarDays = [];
        return;
      }
      if (this.isMock) {
        this.applyMockCalendar();
        return;
      }
      var t = this;
      this.calendarDays = [];
      axios.get('landlord/roomCalendar', {
        params: {
          room_id: roomId,
          year: this.calYear,
          month: this.calMonth
        }
      }).then(function (res) {
        if (t.expanded !== roomId) return;
        if (res.data.status == 1 && res.data.options && res.data.options.days) {
          t.calendarDays = res.data.options.days;
        } else if (res.data && Number(res.data.status) === 403) {
          t.calendarDays = [];
        } else {
          t.toast('読み込みに失敗しました');
        }
      }).catch(function () {
        if (t.expanded !== roomId) return;
        t.toast('読み込みに失敗しました');
      });
      this.loadStayApplications(roomId);
    },
    loadStayApplications: function (roomId) {
      if (!roomId || this.isMock) {
        this.stayApplications = [];
        return;
      }
      var t = this;
      axios.get('landlord/ownerStay', {
        params: {
          room_id: roomId,
          year: this.calYear,
          month: this.calMonth
        }
      }).then(function (res) {
        if (t.expanded !== roomId) return;
        if (res.data.status == 1 && res.data.options && res.data.options.items) {
          t.stayApplications = res.data.options.items;
        } else {
          t.stayApplications = [];
        }
      }).catch(function () {
        if (t.expanded !== roomId) return;
        t.stayApplications = [];
      });
    },
    draftGroups: function () {
      var days = (this.selectedDays || []).slice().filter(function (d) {
        return /^\d{4}-\d{2}-\d{2}$/.test(String(d));
      }).sort();
      var groups = [];
      var i;
      var start;
      var prev;
      var n;
      if (!days.length) return groups;
      start = days[0];
      prev = days[0];
      for (i = 1; i < days.length; i++) {
        n = days[i];
        if (n === this.nextDateKey(prev)) {
          prev = n;
        } else {
          groups.push({ start: start, end: prev });
          start = n;
          prev = n;
        }
      }
      groups.push({ start: start, end: prev });
      return groups;
    },
    nextDateKey: function (ymd) {
      var p = String(ymd || '').split('-');
      if (p.length < 3) return '';
      var dt = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
      if (!isFinite(dt.getTime())) return '';
      dt.setDate(dt.getDate() + 1);
      var y = dt.getFullYear();
      var m = dt.getMonth() + 1;
      var d = dt.getDate();
      return y + '-' + (m < 10 ? '0' + m : String(m)) + '-' + (d < 10 ? '0' + d : String(d));
    },
    dayKey: function (day) {
      var matched;
      var n;
      var y;
      var mo;
      if (!day) return '';
      if (day.date) {
        matched = String(day.date).match(/(\d{4}-\d{2}-\d{2})/);
        if (matched) return matched[1];
      }
      n = Number(day.n);
      y = Number(this.calYear);
      mo = Number(this.calMonth);
      if (!isFinite(n) || n < 1 || !isFinite(y) || !isFinite(mo)) return '';
      return y + '-' + (mo < 10 ? '0' + mo : String(mo)) + '-' + (n < 10 ? '0' + n : String(n));
    },
    isDaySelected: function (day) {
      var key = this.dayKey(day);
      return key !== '' && this.selectedDays.indexOf(key) > -1;
    },
    dayNextTo: function (a, b) {
      var ka = this.dayKey(a);
      var kb = this.dayKey(b);
      var da;
      var db;
      if (!ka || !kb) return false;
      da = new Date(ka + 'T00:00:00');
      db = new Date(kb + 'T00:00:00');
      if (isNaN(da.getTime()) || isNaN(db.getTime())) return false;
      return Math.round((db.getTime() - da.getTime()) / 86400000) === 1;
    },
    dayClass: function (day, index) {
      var cls = {};
      var days = this.calendarDays || [];
      var prev = index > 0 ? days[index - 1] : null;
      var next = index + 1 < days.length ? days[index + 1] : null;
      cls['is-empty'] = day.status === 'empty';
      cls['is-occupied'] = day.status === 'occupied';
      cls['is-stay-pending'] = day.status === 'stay_pending';
      cls['is-stay-approved'] = day.status === 'stay_approved';
      cls['is-outside'] = day.status === 'outside';
      cls['is-selected'] = this.isDaySelected(day);
      if (cls['is-selected'] && index % 7 !== 0 && prev && this.isDaySelected(prev) && this.dayNextTo(prev, day)) {
        cls['is-join-left'] = true;
      }
      if (cls['is-selected'] && index % 7 !== 6 && next && this.isDaySelected(next) && this.dayNextTo(day, next)) {
        cls['is-join-right'] = true;
      }
      this.applyDayLines(cls, days, day, index, prev, next);
      return cls;
    },
    dayOutlineRank: function (day) {
      if (!day || day.status === 'outside') return 0;
      if (day.status === 'stay_pending') return 2;
      if (day.status === 'empty' && !this.isDaySelected(day)) return 1;
      return 0;
    },
    applyDayLines: function (cls, days, day, index, prev, next) {
      var col = index % 7;
      var left = col > 0 ? prev : null;
      var right = col < 6 ? next : null;
      var above = index >= 7 ? days[index - 7] : null;
      var below = index + 7 < days.length ? days[index + 7] : null;
      var rank = this.dayOutlineRank(day);
      var leftRank;
      var rightRank;
      var aboveRank;
      var belowRank;
      if (rank <= 0) return;
      leftRank = this.dayOutlineRank(left);
      rightRank = this.dayOutlineRank(right);
      aboveRank = this.dayOutlineRank(above);
      belowRank = this.dayOutlineRank(below);
      cls['is-line'] = true;
      if (leftRank === 0 || rank > leftRank) cls['is-line-left'] = true;
      if (rightRank === 0 || rank >= rightRank) cls['is-line-right'] = true;
      if (aboveRank === 0 || rank > aboveRank) cls['is-line-top'] = true;
      if (belowRank === 0 || rank >= belowRank) cls['is-line-bottom'] = true;
    },
    formatDateSpan: function (from, to) {
      var a = this.parseYmd(from);
      var b = this.parseYmd(to || from);
      if (!a) return '';
      if (!b || (a.y === b.y && a.m === b.m && a.d === b.d)) {
        return a.m + '月' + a.d + '日';
      }
      if (a.y === b.y && a.m === b.m) {
        return a.m + '月' + a.d + '日〜' + b.d + '日';
      }
      return a.m + '月' + a.d + '日〜' + b.m + '月' + b.d + '日';
    },
    parseYmd: function (value) {
      var m = String(value || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
      if (!m) return null;
      return { y: parseInt(m[1], 10), m: parseInt(m[2], 10), d: parseInt(m[3], 10) };
    },
    cancelStay: function (row) {
      if (!row || !row.id || this.isMock) return;
      this.cancelTarget = row;
      this.cancelConfirmVisible = true;
    },
    confirmCancelStay: function () {
      var row = this.cancelTarget;
      this.cancelTarget = null;
      if (!row || !row.id) return;
      var t = this;
      axios.post('landlord/ownerStay/cancel/' + row.id).then(function (res) {
        if (res.data.status == 1) {
          t.loadStayApplications(t.expanded);
          t.loadCalendar(t.expanded);
          return;
        }
        t.toast((res.data && res.data.msg) || '取消に失敗しました');
      }).catch(function () {
        t.toast('取消に失敗しました');
      });
    },
    applyMockCalendar: function () {
      var occupied = this.occupiedDays;
      var days = [];
      var i;
      for (i = 1; i <= 30; i++) {
        days.push({
          n: i,
          status: occupied.indexOf(i) > -1 ? 'occupied' : 'empty'
        });
      }
      this.calendarDays = days;
    },
    onMockCollapse: function () {
      this.expanded = null;
    },
    onMockExpand: function () {
      if (this.rooms[0]) {
        this.expanded = this.rooms[0].id;
        this.loadCalendar(this.rooms[0].id);
      }
    },
    onMockEmptyRooms: function () {
      mockData.emptyRooms = true;
      this.rooms = [];
      this.expanded = null;
      this.calendarDays = [];
    },
    shiftCalMonth: function (delta) {
      var y = Number(this.calYear);
      var m = Number(this.calMonth) + Number(delta);
      if (!isFinite(y)) y = (new Date()).getFullYear();
      if (!isFinite(m)) m = 1;
      while (m < 1) {
        m += 12;
        y -= 1;
      }
      while (m > 12) {
        m -= 12;
        y += 1;
      }
      this.applyCalMonth(y, m);
    },
    openCalMonthPicker: function () {
      this.calPickerYear = this.calYear;
      this.calPickerMonth = this.calMonth;
      this.ensurePickerMonths(this.expanded, this.calPickerYear);
      this.calMonthPickerVisible = true;
    },
    pickCalMonth: function (month) {
      if (!this.monthSelectable(this.expanded, this.calPickerYear, month)) return;
      this.calPickerMonth = month;
    },
    confirmCalMonth: function () {
      if (!this.monthSelectable(this.expanded, this.calPickerYear, this.calPickerMonth)) return;
      this.calMonthPickerVisible = false;
      this.applyCalMonth(this.calPickerYear, this.calPickerMonth);
    },
    applyCalMonth: function (year, month) {
      var y = Number(year);
      var m = Number(month);
      if (!isFinite(y) || !isFinite(m) || m < 1 || m > 12) return;
      this.calYear = y;
      this.calMonth = m;
      if (this.expanded) this.loadCalendar(this.expanded);
    },
    toggleRoom: function (id) {
      if (this.expanded === id) {
        this.expanded = null;
        return;
      }
      this.expanded = id;
      this.selectedDays = [];
      this.focusBookableMonth(id);
      this.loadCalendar(id);
    },
    toggleDay: function (day) {
      var key;
      var i;
      if (!day || day.status !== 'empty') return;
      key = this.dayKey(day);
      if (!key) return;
      i = this.selectedDays.indexOf(key);
      if (i > -1) this.selectedDays.splice(i, 1);
      else this.selectedDays.push(key);
    },
    onApplyStay: function () {
      if (this.isMock) {
        this.noticeTitle = '通知';
        this.noticeBody = '準備中';
        this.noticeVisible = true;
        return;
      }
      if (!this.selectedDays.length || !this.expanded) {
        this.toast('日付を選択してください');
        return;
      }
      var t = this;
      var dates = [];
      var i;
      var key;
      for (i = 0; i < this.selectedDays.length; i++) {
        key = String(this.selectedDays[i] || '');
        if (/^\d{4}-\d{2}-\d{2}$/.test(key)) dates.push(key);
      }
      if (!dates.length) {
        this.toast('日付を選択してください');
        return;
      }
      axios.post('landlord/ownerStay', {
        room_id: this.expanded,
        dates: dates
      }).then(function (res) {
        var status = res.data && res.data.status;
        var msg = res.data && res.data.msg;
        if (status == 1) {
          t.noticeTitle = '通知';
          t.noticeBody = '試泊申請を送信しました';
          t.noticeVisible = true;
          t.selectedDays = [];
          t.loadCalendar(t.expanded);
        } else if (status == 422) {
          t.noticeTitle = '通知';
          t.noticeBody = msg || '該当日に予約があるため申請できません。別日を選択してください。';
          t.noticeVisible = true;
        } else {
          t.toast(msg || '送信に失敗しました');
        }
      }).catch(function () {
        t.toast('送信に失敗しました');
      });
    },
    onPdf: function () {
      if (this.pdfBusy) return;
      var source = this.$el;
      if (!source || !source.querySelector) {
        this.toast('PDFの書き出しに失敗しました');
        return;
      }
      var t = this;
      var capture = null;
      this.pdfBusy = true;
      var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
      fontsReady.then(function () {
        return import('html2canvas');
      }).then(function (mod) {
        var shoot = mod.default || mod;
        capture = mountFoldedDashboard(source);
        var scale = 2;
        if (capture.width * scale > 4096 || capture.height * scale > 12000) scale = 1;
        return shoot(capture.node, {
          backgroundColor: '#ffffff',
          scale: scale,
          useCORS: true,
          logging: false,
          width: capture.width,
          height: capture.height,
          windowWidth: capture.width,
          windowHeight: Math.max(capture.height, window.innerHeight || 0)
        });
      }).then(function (canvas) {
        return canvasToJpegPdf(canvas, capture.width, capture.height);
      }).then(function (bytes) {
        savePdfBytes(bytes, t.year + '年度運営状況.pdf');
      }).catch(function () {
        t.toast('PDFの書き出しに失敗しました');
      }).then(function () {
        t.pdfBusy = false;
        if (capture && capture.host && capture.host.parentNode) capture.host.parentNode.removeChild(capture.host);
      });
    },
    onOpenPub: function (type) {
      this.monthBoardKind = 'publication';
      this.monthBoardType = type;
      this.monthBoardLive = !this.isMock;
      this.monthBoardFocusYear = 0;
      this.monthBoardFocusMonth = 0;
      this.monthBoardVisible = true;
    },
    printHtml: function (html) {
      var w = window.open('', '_blank');
      if (!w) return false;
      w.document.open();
      w.document.write(html);
      w.document.close();
      w.focus();
      w.print();
      return true;
    },
    onPrintMonth: function () {
      this.monthBoardKind = 'settlement';
      this.monthBoardLive = !this.isMock;
      this.monthBoardFocusYear = this.calYear;
      this.monthBoardFocusMonth = this.calMonth;
      this.monthBoardVisible = true;
    },
    onPrintAnnual: function () {
      if (this.isMock) {
        this.toast('まだ公開されていません');
        return;
      }
      var t = this;
      axios.get('landlord/settlement/annualPdf', {
        params: { year: this.year }
      }).then(function (res) {
        var html = res.data && res.data.options && res.data.options.html;
        if (res.data && res.data.status == 1 && html) {
          t.printHtml(html);
          return;
        }
        t.toast('まだ公開されていません');
      }).catch(function () {
        t.toast('読み込みに失敗しました');
      });
    },
    goSettlement: function () {
      this.$router.push({
        path: '/owner/settlement',
        query: { year: this.calYear, month: this.calMonth }
      });
    },
    goContract: function () {
      this.$router.push('/owner/contract');
    },
    shiftYear: function (delta) {
      var next = Number(this.year) + delta;
      if (!isFinite(next) || next < 2000 || next > 2100) return;
      this.year = next;
    },
    pickChartYear: function (which, year) {
      var y = Number(year);
      if (!isFinite(y)) return;
      if (which === 'A') {
        this.chart.yearA = y;
        this.yearPopA = false;
      } else {
        this.chart.yearB = y;
        this.yearPopB = false;
      }
      this.onChartYearChange();
    },
    chartScale: function () {
      var max = 0;
      var seriesList = [this.chart.seriesA || [], this.chart.seriesB || []];
      var hiddenList = [this.chart.hiddenA || [], this.chart.hiddenB || []];
      var s;
      var i;
      var v;
      var peak;
      for (s = 0; s < seriesList.length; s++) {
        for (i = 0; i < seriesList[s].length && i < 12; i++) {
          if (hiddenList[s][i]) continue;
          v = Number(seriesList[s][i]);
          if (isFinite(v) && v > max) max = v;
        }
      }
      peak = 100;
      if (max > 100) peak = max * 1.2;
      return { peak: peak, max: max };
    },
    chartTickLabel: function (value) {
      var v = Math.round(Number(value) * 10) / 10;
      if (!isFinite(v)) v = 0;
      if (Math.abs(v - Math.round(v)) < 0.05) return String(Math.round(v));
      return String(v);
    },
    chartAmountText: function (value) {
      var v;
      var text;
      if (value == null || value === '-') return '—';
      v = Math.round(Number(value) * 100) / 100;
      if (!isFinite(v)) v = 0;
      text = String(v);
      if (text.indexOf('.') >= 0) text = text.replace(/0+$/, '').replace(/\.$/, '');
      return text + '万円';
    },
    chartPointList: function (series, hidden) {
      var out = [];
      var i;
      var v;
      hidden = hidden || [];
      for (i = 0; i < 12; i++) {
        if (hidden[i]) {
          out.push(null);
          continue;
        }
        v = series && series[i] != null ? Number(series[i]) : 0;
        if (!isFinite(v) || v < 0) v = 0;
        out.push(v);
      }
      return out;
    },
    ownerChartOption: function () {
      var t = this;
      var scale = this.chartScale();
      var peak = scale.peak;
      var months = [];
      var m;
      var axisText = { color: '#341717', fontSize: 9, fontWeight: 700 };
      for (m = 1; m <= 12; m++) months.push(String(m));
      return {
        animationDuration: 200,
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#ffffff',
          borderWidth: 0,
          padding: [6, 8],
          extraCssText: 'box-shadow: 2px 2px 10px 1px rgba(0,0,0,0.3); border-radius: 3px;',
          textStyle: { fontSize: 12, fontWeight: 700 },
          axisPointer: {
            type: 'line',
            lineStyle: { color: '#b8cad1', width: 1 }
          },
          formatter: function (params) {
            var html = '';
            var i;
            var row;
            var color;
            var rows = params || [];
            for (i = 0; i < rows.length; i++) {
              row = rows[i];
              color = i === 0 ? '#d88384' : '#999999';
              html += '<div style="color:' + color + ';line-height:16px;">' + row.seriesName + '年　' + t.chartAmountText(row.value) + '</div>';
            }
            return html;
          }
        },
        grid: { left: 8, right: 8, top: 36, bottom: 4, containLabel: true },
        xAxis: {
          type: 'category',
          data: months,
          boundaryGap: false,
          axisTick: { show: false },
          axisLine: { lineStyle: { color: '#d5d5d5' } },
          axisLabel: axisText
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: peak,
          interval: peak / 5,
          name: '稼働率(%)',
          nameLocation: 'end',
          nameGap: 8,
          nameTextStyle: { color: '#4a9fbd', fontSize: 9, fontWeight: 700, align: 'left' },
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: {
            color: '#341717',
            fontSize: 9,
            fontWeight: 700,
            formatter: function (value) { return t.chartTickLabel(value); }
          },
          splitLine: { lineStyle: { color: '#d5d5d5' } }
        },
        series: [
          {
            name: String(this.chart.yearA),
            type: 'line',
            smooth: true,
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 7,
            connectNulls: true,
            data: this.chartPointList(this.chart.seriesA, this.chart.hiddenA),
            lineStyle: { width: 2, color: '#d88384' },
            itemStyle: { color: '#d88384' }
          },
          {
            name: String(this.chart.yearB),
            type: 'line',
            smooth: true,
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 7,
            connectNulls: true,
            data: this.chartPointList(this.chart.seriesB, this.chart.hiddenB),
            lineStyle: { width: 2, color: '#999999' },
            itemStyle: { color: '#999999' }
          }
        ]
      };
    },
    scheduleOwnerChart: function () {
      var t = this;
      this.$nextTick(function () {
        t.renderOwnerChart();
      });
    },
    renderOwnerChart: function () {
      var el = this.$refs.ownerChart;
      if (Array.isArray(el)) el = el[0];
      if (!el) {
        this.disposeOwnerChart();
        return;
      }
      if (this._ownerChart && this._ownerChartEl !== el) {
        this.disposeOwnerChart();
      }
      if (!this._ownerChart) {
        this._ownerChart = echarts.init(el);
        this._ownerChartEl = el;
      }
      this._ownerChart.setOption(this.ownerChartOption(), true);
      this._ownerChart.resize();
    },
    resizeOwnerChart: function () {
      if (this._ownerChart) this._ownerChart.resize();
    },
    disposeOwnerChart: function () {
      if (this._ownerChart) {
        this._ownerChart.dispose();
        this._ownerChart = null;
      }
      this._ownerChartEl = null;
    }
  }
};
